'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _get = function get(_x, _x2, _x3) {
  var _again = true;
  _function: while (_again) {
    var object = _x,
      property = _x2,
      receiver = _x3;
    _again = false;
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);
      if (parent === null) {
        return undefined;
      } else {
        _x = parent;
        _x2 = property;
        _x3 = receiver;
        _again = true;
        desc = parent = undefined;
        continue _function;
      }
    } else if ('value' in desc) {
      return desc.value;
    } else {
      var getter = desc.get;
      if (getter === undefined) {
        return undefined;
      }
      return getter.call(receiver);
    }
  }
};
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _actionsMcu = require('../actions/mcu');
var _actionsVideoRoom = require('../actions/videoRoom');
var VideoRoom = function (_Component) {
  _inherits(VideoRoom, _Component);
  function VideoRoom() {
    _classCallCheck(this, VideoRoom);
    _get(Object.getPrototypeOf(VideoRoom.prototype), 'constructor', this).apply(this, arguments);
  }
  _createClass(VideoRoom, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      console.log('inside VIDEO ROOM PROPS', nextProps);
      var dispatch = nextProps.dispatch;

      //Attach local plugin
      if (nextProps.janusInstance !== this.props.janusInstance) {
        dispatch((0, _actionsVideoRoom.attachLocalFeed)());
      }
      //Join to the room
      if (nextProps.addedFeed !== this.props.addedFeed) {
        //Publish local feed
        if (!nextProps.addedFeed.remote && !!nextProps.autoPublish) {
          var mediaAsExternalParam = !!nextProps.media;
          var audio = mediaAsExternalParam ? nextProps.media.audio : true;
          var video = mediaAsExternalParam ? nextProps.media.video : true;
          console.log('media from extenal: ', audio, video);
          dispatch((0, _actionsVideoRoom.publishLocalFeed)(audio, video));
        }
      }
      //Change dataSupport
      if (nextProps.dataSupport !== this.props.dataSupport) {
        (0, _actionsVideoRoom.setDataSupport)(nextProps.dataSupport);
      }
      //Retry
      if (nextProps.error !== this.props.error) {
        if (nextProps.error.type === _actionsMcu.CREATE_SESSION_ERROR || nextProps.error.type === _actionsVideoRoom.ROOM_ICE_ERROR) {
          if (nextProps.janusInstance) {
            nextProps.janusInstance.destroy({
              success: this.retry.bind(this)
            });
          } else {
            this.retry();
          }
        }
      }
    }
  }, {
    key: 'retry',
    value: function retry() {
      (0, _actionsVideoRoom.reset)();
      setTimeout(this.initMcu.bind(this), this.props.retry.countdown);
    }
  }, {
    key: 'initMcu',
    value: function initMcu() {
      var _props = this.props;
      var dispatch = _props.dispatch;
      var room = _props.room;
      var user = _props.user;
      var media = _props.media;
      var janus = _props.janus;
      var publishers = _props.publishers;
      var retry = _props.retry;
      var debug = _props.debug;
      dispatch((0, _actionsMcu.createSession)({
        room: room,
        user: user,
        media: media,
        janus: janus,
        publishers: publishers,
        retry: retry,
        debug: debug
      }));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _actionsVideoRoom.setDataSupport)(this.props.dataSupport);
      (0, _actionsVideoRoom.reset)();
      this.initMcu();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.janusInstance) {
        this.props.janusInstance.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2['default'].createElement('div', null, this.props.children);
    }
  }]);
  return VideoRoom;
}(_react.Component);
VideoRoom.propTypes = {
  room: _propTypes2['default'].object.isRequired,
  user: _propTypes2['default'].object.isRequired,
  media: _propTypes2['default'].object,
  janus: _propTypes2['default'].object.isRequired,
  publishers: _propTypes2['default'].number.isRequired,
  retry: _propTypes2['default'].object,
  janusInstance: _propTypes2['default'].object,
  addedFeed: _propTypes2['default'].object,
  error: _propTypes2['default'].object,
  debug: _propTypes2['default'].bool,
  autoPublish: _propTypes2['default'].bool,
  dataSupport: _propTypes2['default'].bool
};
function selector(state) {
  var janusInstance = state.mcu.janus;
  var addedFeed = state.videoRoom.addedFeed;
  var _state$janusConfig = state.janusConfig;
  var media = _state$janusConfig.media;
  var janusConfig = _objectWithoutProperties(_state$janusConfig, ['media']);
  var error = state.mcu.error || state.videoRoom.error || null;
  return Object.assign({
    janusInstance: janusInstance,
    addedFeed: addedFeed,
    retry: {
      countdown: 5000
    },
    error: error
  }, janusConfig);
}
exports['default'] = (0, _reactRedux.connect)(selector)(VideoRoom);
module.exports = exports['default'];